import styled from "styled-components";

export const CodeContainer = styled.div`
  background: #f7f7f8;
  border-radius: 4px;
  overflow: hidden;
  margin: 1rem 0;
  border: 1px solid #ededed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  
  &.code-block {
    /* Ensure our code blocks are not affected by ContentBox theming */
  }
`;

export const CodeHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 1rem;
    background: #e8e8e8;
    border-bottom: 1px solid #ededed;
`;

export const Language = styled.span`
  color: #161616;
  font-size: 0.875rem;
  font-weight: 600;
`;

export const CopyButton = styled.button`
  padding: 0.375rem 0.75rem;
  background: var(--brand);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(83, 210, 61, 0.3);
  }
`;

export const CodeContent = styled.div`
    padding: 1rem;
    overflow-x: auto;
    background: #efefef;

    pre {
        margin: 0;
        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
        font-size: 0.875rem;
        line-height: 1.5;

        code {
            color: #161616;
            background: none;
            padding: 0;
            border-radius: 0;

            .keyword {
                color: var(--brand);
            }

            .string {
                color: #0c5c07;
            }

            .comment {
                color: #828A95;
                font-style: italic;
            }

            .function {
                color: #0267e5;
            }
        }
    }
`;

export const ClickableUrlContent = styled.a`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    text-decoration: none;
    color: #0267e5;
    transition: all 0.2s ease;
    cursor: pointer;

    code {
        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
        font-size: 0.875rem;
        line-height: 1.5;
        color: #0267e5;
        background: none;
        padding: 0;
        border-radius: 0;
    }

    &:hover {
        color: #0056b3;
        text-decoration: underline;

        code {
            color: #0056b3;
        }
    }
`;

export const ExternalLinkIcon = styled.img`
    width: 16px;
    height: 16px;
    opacity: 0.7;
    flex-shrink: 0;
`;